export const styles = theme => ({
    root: {
      marginTop: theme.spacing(2),
      padding : theme.spacing(3),
      width : '100%',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom : '8px',
    },
    title : {
      fontSize : '1.5rem',
    },
    textField: {
      marginRight: theme.spacing(1),
      width: '100%',
    },
    padding24 : {
      paddingRight : '24px !important'
    },
    menu: {
      width: '15%',
    },
    input : {
      
    },
    label : {
      
    },
    actives : {
      fontSize: '0.8rem',      
      marginLeft : '60px',
      display : 'inline-block'
    },
    button: {
      float: 'right',
    },
    btnGGMap : {
      margin: '8px 0px 0px 0px',
    },
    switchBase: {
      '&$switchChecked': {
        color: theme.palette.common.white,
        '& + $switchBar': {
          backgroundColor: '#52d869',
        },
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.sharp,
      }),
    },
    switchChecked: {
      transform: 'translateX(15px)',
      '& + $switchBar': {
        opacity: 1,
        border: 'none',
      },
    },
    switchBar: {
      borderRadius: 13,
      width: 42,
      height: 26,
      marginTop: -13,
      marginLeft: -21,
      border: 'solid 1px',
      borderColor: theme.palette.grey[400],
      backgroundColor: theme.palette.grey[500],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    switchIcon: {
      width: 24,
      height: 24,
    },
    switchIconChecked: {
      boxShadow: theme.shadows[1],
    },
  });